enum Breakpoints {
  desktop = 1000,
}

export default Breakpoints;
